export const TENANT = "spaceguide";

// You probably don't need to change these
export const API_BASE_URL = `https://api.leanspace.io`;
export const AWS_REGION = "eu-central-1";

// Custom
export const WEBHOOK_URL = "https://enuzc5eykicmiu9.m.pipedream.net";
